
// Leading characters a spreadsheet treats as the start of a formula.
const FORMULA_PREFIXES = ['=', '+', '-', '@', '\t', '\r'];

/** Makes free text from users safe to open in a spreadsheet, without changing numbers. */
export const escapeCsvFormula = <Value>(value: Value): Value | string => (
  typeof value === 'string' && FORMULA_PREFIXES.some((prefix) => value.startsWith(prefix))
    ? `'${value}`
    : value
);

/**
 * `withByteOrderMark` makes Excel read non-ASCII text as UTF-8. Leave it off for import
 * templates: the import parser doesn't strip it, so it would corrupt the first header.
 */
export const downloadCsv = (
  data: string,
  title: string,
  { withByteOrderMark = false }: { withByteOrderMark?: boolean } = {},
) => {
  const blob = new Blob(
    [withByteOrderMark ? `\uFEFF${data}` : data],
    { type: 'text/csv;charset=utf-8' },
  );

  const a: HTMLAnchorElement = document.createElement('a');
  document.body.appendChild(a);
  a.style.display = 'none';

  const url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = `${title}.csv`;
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};
